const testimonials = [
  {
    quote: 'Sky Edge stood up our tokenization pilot in weeks, not quarters. The compliance layer alone saved us six months of regulatory back-and-forth.',
    name: 'Aram Petrosyan',
    role: 'Head of Digital Assets',
    company: 'Meridian Realty Group',
    initials: 'AP',
  },
  {
    quote: 'Their engineers operate like a co-founding team. From data centre migration to our internal AI copilot, one accountable partner across the stack.',
    name: 'Priya Krishnan',
    role: 'CTO',
    company: 'NorthArc Fintech',
    initials: 'PK',
  },
  {
    quote: 'Omni AI replaced four separate model subscriptions and gave leadership a single view of AI spend. Our finance team finally slept.',
    name: 'David Mkrtchyan',
    role: 'VP Engineering',
    company: 'ByteHarbor Systems',
    initials: 'DM',
  },
];

export default function Testimonials() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mb-12 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider">
            <i className="ri-double-quotes-l"></i>
            Client voices
          </div>
          <h4 className="mt-5 font-heading font-bold text-3xl md:text-5xl text-foreground-900 leading-tight">
            <a href="#testimonials" className="hover:text-primary-700 transition-colors cursor-pointer">
              Trusted by teams building at the edge.
            </a>
          </h4>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div key={t.name} className="relative p-6 md:p-7 rounded-lg bg-background-100 border border-background-200 flex flex-col">
              <i className="ri-double-quotes-l text-4xl text-accent-500 mb-3"></i>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed flex-1">{t.quote}</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-background-200">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 font-heading font-semibold">
                  {t.initials}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role} · {t.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}